export default {
  route: {
    dashboard: 'Dashboard',
    introduction: 'Introduction',
    deviceManage: 'DeviceManage',
    guide: 'Guide',
    permission: 'Permission',
    pagePermission: 'Page Permission',
    directivePermission: 'Directive Permission',
    icons: 'Icons',
    components: 'Components',
    componentIndex: 'Introduction',
    tinymce: 'Tinymce',
    markdown: 'Markdown',
    jsonEditor: 'JSON Editor',
    dndList: 'Dnd List',
    splitPane: 'SplitPane',
    avatarUpload: 'Avatar Upload',
    dropzone: 'Dropzone',
    sticky: 'Sticky',
    countTo: 'CountTo',
    componentMixin: 'Mixin',
    backToTop: 'BackToTop',
    dragDialog: 'Drag Dialog',
    dragKanban: 'Drag Kanban',
    charts: 'Charts',
    keyboardChart: 'Keyboard Chart',
    lineChart: 'Line Chart',
    mixChart: 'Mix Chart',
    example: 'Example',
    nested: 'Nested Routes',
    menu1: 'Menu 1',
    'menu1-1': 'Menu 1-1',
    'menu1-2': 'Menu 1-2',
    'menu1-2-1': 'Menu 1-2-1',
    'menu1-2-2': 'Menu 1-2-2',
    'menu1-3': 'Menu 1-3',
    menu2: 'Menu 2',
    Table: 'Table',
    dynamicTable: 'Dynamic Table',
    dragTable: 'Drag Table',
    inlineEditTable: 'Inline Edit',
    complexTable: 'Complex Table',
    treeTable: 'Tree Table',
    customTreeTable: 'Custom TreeTable',
    tab: 'Tab',
    form: 'Form',
    createArticle: 'Create Article',
    editArticle: 'Edit Article',
    articleList: 'Article List',
    errorPages: 'Error Pages',
    page401: '401',
    page404: '404',
    errorLog: 'Error Log',
    excel: 'Excel',
    exportExcel: 'Export Excel',
    selectExcel: 'Export Selected',
    uploadExcel: 'Upload Excel',
    zip: 'Zip',
    exportZip: 'Export Zip',
    theme: 'Theme',
    clipboardDemo: 'Clipboard',
    i18n: 'I18n',
    externalLink: 'External Link',
    normalDevice: 'Device List',
    groupDevice: 'Group Device',
    baseModule: 'Base Module',
    statusManage: 'Status Manage',
    applicationManage: 'Application Manage',
    roleManage: 'Role Manage',
    fieldList: 'Field List',
    personalCenter: 'Personal Center',
    staffManage: 'Staff Manage',
    accountManage: 'Account Manage',
    refundRecord: 'Refund Record',
    cashaudit: 'Cash Audit',
    transferAccount: 'Transfer Account',
    advertiseManage: 'Advertise Manage',
    courierAudit: 'Courier Audit',
    userManage: 'UserManage',
    expressCompany: 'Express Company',
    deviceList: 'Device Manage',
    lineStatus: 'Line State',
    binDingAgents: 'Binding Agents',
    shopManages: 'Shop Manages'
  },
  navbar: {
    logOut: 'Log Out',
    dashboard: 'Dashboard',
    github: 'Github',
    screenfull: 'Screenfull',
    theme: 'Theme',
    size: 'Global Size'
  },
  login: {
    title: 'Login Form',
    logIn: 'Log in',
    username: 'Username',
    password: 'Password',
    any: 'any',
    thirdparty: 'Or connect with',
    thirdpartyTips: 'Can not be simulated on local, so please combine you own business simulation! ! !'
  },
  documentation: {
    documentation: 'Documentation',
    github: 'Github Repository'
  },
  permission: {
    roles: 'Your roles',
    switchRoles: 'Switch roles'
  },
  guide: {
    description: 'The guide page is useful for some people who entered the project for the first time. You can briefly introduce the features of the project. Demo is based on ',
    button: 'Show Guide'
  },
  components: {
    documentation: 'Documentation',
    tinymceTips: 'Rich text editor is a core part of management system, but at the same time is a place with lots of problems. In the process of selecting rich texts, I also walked a lot of detours. The common rich text editors in the market are basically used, and the finally chose Tinymce. See documentation for more detailed rich text editor comparisons and introductions.',
    dropzoneTips: 'Because my business has special needs, and has to upload images to qiniu, so instead of a third party, I chose encapsulate it by myself. It is very simple, you can see the detail code in @/components/Dropzone.',
    stickyTips: 'when the page is scrolled to the preset position will be sticky on the top.',
    backToTopTips1: 'When the page is scrolled to the specified position, the Back to Top button appears in the lower right corner',
    backToTopTips2: 'You can customize the style of the button, show / hide, height of appearance, height of the return. If you need a text prompt, you can use element-ui el-tooltip elements externally',
    imageUploadTips: 'Since I was using only the vue@1 version, and it is not compatible with mockjs at the moment, I modified it myself, and if you are going to use it, it is better to use official version.'
  },
  table: {
    title: 'Title',
    type: 'Type',
    remark: 'Remark',
    search: 'Search',
    add: 'Add',
    addTime: 'Add Time',
    export: 'Export',
    id: 'No',
    number: 'Number',
    name: 'Name',
    module: 'Module',
    moduleName: 'ModuleName',
    entityName: 'EntityName',
    remarks: 'Remarks',
    date: 'Date',
    status: 'Status',
    actions: 'Actions',
    edit: 'Edit',
    publish: 'Publish',
    delete: 'Delete',
    cancel: 'Cancel',
    confirm: 'Confirm',
    imei: 'ImeiNo',
    address: 'Address',
    size: 'Size',
    version: 'VersionType',
    saveType: 'SaveType',
    owner: 'Owner',
    versionName: 'VersionName',
    deviceName: 'DeviceName',
    lastConnTime: 'LastConnectTime',
    lastModifyTime: 'LastModifyTime',
    cellNum: 'CellNumber',
    userCount: 'UserCount',
    totalIncome: 'TotalIncome',
    expireTime: 'ExpireTime',
    'Data_statistics': 'Data statistics',
    submit: 'Submit',
    detail: 'Detail',
    renew: 'Renew',
    useStatus: 'UseStatus',
    boxNum: 'BoxNumber',
    Userphone: 'Userphone',
    startTime: 'StartTime',
    endTime: 'EndTime',
    lng: 'longitude',
    lat: 'latitude',
    sort: 'Sort',
    route: 'Route',
    permission: 'Permission',
    btnPermission: 'Button Permission',
    templateName: 'Template Name',
    templateIntroduce: 'Template Introduce',
    lockNum: 'Lock No',
    lockIndex: 'Lock Index',
    advertiseName: 'Advertise Name',
    advertiseIntro: 'Advertise Intro',
    videoUrl: 'Video Url',
    picUrl: 'Picture Url',
    belongsUser: 'Belongs User',
    adverDetail: 'Advertise Detail',
    groupName: 'GroupName',
    groupIntro: 'GroupIntro',
    deviceManage: 'DeviceManage',
    adsManage: 'AdsManage',
    deviceNum: 'DeviceTotal',
    adsTotal: 'AdsTotal',
    allotAds: 'AllotAds',
    allotDevice: 'AllotDevice',
    unbind: 'Unbind',
    preview: 'Preview',
    bind: 'Bind',
    unBind: 'UnBind',
    loginNo: 'LoginNo',
    userName: 'UserName',
    sex: 'Sex',
    role: 'Role',
    password: 'Password',
    telphone: 'TelPhone',
    email: 'Email',
    birthDay: 'BirthDay',
    idCard: 'IdCard',
    realName: 'RealName',
    avatar: 'Avatar',
    resetPwd: 'ResetPassword',
    changePwd: 'changePassword',
    renewTime: 'RenewTime',
    expense: 'Expense',
    payway: 'PayWay',
    payQRcode: 'PayQRcode',
    operatUser: 'OperatUser',
    importBoxSizeTemp: 'ImportBoxSizeTemp',
    orderNo: 'OrderNo',
    adds: 'Batch Add',
    addBox: 'Add Box',
    addBoxs: 'Batch Add Box',
    revenueType: 'Revenue Type',
    companyName: 'Company Name',
    companyNamesma: 'Company Name Abbreviation',
    companyAddress: 'Company Address',
    boxList: 'Box List',
    fieldName: 'Field Name',
    fieldAddress: 'Field Address',
    MonthlyFee: 'Monthly Fee',
    MonthlyDiscount: 'Monthly Discount',
    UpdateTime: 'Update Time',
    qrystaff: 'Look Staff',
    fieldKey: 'Field Key',
    DetailAdress: 'Detail Adress',
    back: 'Back',
    qrymember: 'Look Member',
    orderManage: 'Order Manage',
    boxNo: 'Box No',
    OrderType: 'Order Type',
    'PayMoney ': 'Pay Money',
    OrderNo: 'Order No',
    OrderState: 'Order State',
    PayType: 'Pay Type',
    refund: 'Refund',
    TotalMoney: 'Total Money',
    Identity: 'Identity',
    BoxNo: 'Box No'
  },
  errorLog: {
    tips: 'Please click the bug icon in the upper right corner',
    description: 'Now the management system are basically the form of the spa, it enhances the user experience, but it also increases the possibility of page problems, a small negligence may lead to the entire page deadlock. Fortunately Vue provides a way to catch handling exceptions, where you can handle errors or report exceptions.',
    documentation: 'Document introduction'
  },
  excel: {
    export: 'Export',
    selectedExport: 'Export Selected Items',
    placeholder: 'Please enter the file name(default excel-list)'
  },
  zip: {
    export: 'Export',
    placeholder: 'Please enter the file name(default file)'
  },
  theme: {
    change: 'Change Theme',
    documentation: 'Theme documentation',
    tips: 'Tips: It is different from the theme-pick on the navbar is two different skinning methods, each with different application scenarios. Refer to the documentation for details.'
  },
  tagsView: {
    refresh: 'Refresh',
    close: 'Close',
    closeOthers: 'Close Others',
    closeAll: 'Close All'
  }
}
